import { Base64 } from "js-base64";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import {
  AppContext,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";
import { AlertLayer } from "../../components/UI/Dialog";
import { InputDiv } from "../../components/UI/INPUT/InputDiv";
import { ContainerNew, SubMenu, openLayerFn } from "../Layout";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import { PostApi1916 } from "../../modules/network/padoPost";
import IcCheckOn from "../../resources/images/icon/checkbox/checkbox_select.svg";

export default (props) => {
  const { hpKey } = props;
  const { userinfo, phonecfg, cfg } = useContext(AppContext);
  const defaultInfo = JSON.parse(Base64.decode(props.match.params.defaultInfo));
  const [gender, setGender] = useState(defaultInfo.sex);
  const [dupList, setDupList] = useState("");

  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    url: "",
  });

  const handleAlert = (title, msg, movePage) => {
    setDialog({
      title: title,
      msg: msg,
      url: movePage ? movePage : "",
    });

    openLayerFn($(".alert-layer"));
  };

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}
    >
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          updateHsptCnntEvent();
        }}
      >
        등록
      </BtnNext>
    </div>
  );
  
  const checkInputEmpty = () => {
    //ID, password, passwordCheck
    if ($("input[name=userName]").val() == "") {
      handleAlert("", "이름을 입력하세요.");
      return false;
    }
    if ($("input[name=birth]").val() == "") {
      handleAlert("", "생년월일 8자리를 입력하세요.");
      return false;
    } else if ($("input[name=birth]").val().length < 8) {
      handleAlert("", "생년월일 8자리를 입력하세요.");
      return false;
    }

    if ($("input[name=userPhone]").val() == "") {
      handleAlert("", "휴대폰 번호를 입력하세요.");
      return false;
    } else if ($("input[name=userPhone]").val().length < 10) {
      handleAlert("", "휴대폰 번호를 확인하세요.");
      return false;
    }

    if (!gender) {
      handleAlert("", "성별을 선택하세요.");
      return false;
    }

    return true;
  };

  const settingUserInfo = () => {
    if (checkInputEmpty()) {
      // 가입여부 확인
      // 중복된 정보 있을시 중복리스트 조회 후 가입유도
      handleFindID("N");
    }
  };

  const updateHsptCnntEvent = () => {

    if($("#privateApply").is(":checked") == true) {
      let userinfoCst = {
        userName: $("input[name=userName]").val().trim(),
        birth: $("input[name=birth]").val(),
        sex: gender,
        userPhone: $("input[name=userPhone]").val(),
      };
      PostApi1916(userinfo, cfg, phonecfg, props.match.params.hpKey, props.match.params.type, $("input[name=attchNo]").val(), userinfoCst)
      .then(res => {
          if(res.resultMsg === 'SUCC') {
            handleAlert('', '병원등록정보가 수정되었습니다.', '/cnntHspt/0');
          } else if(res.resultMsg === "LOGOUT") {
              // openLayerFn($(".alert-layer-logout"));
              handleAlert('', '다른 기기에 로그인한 계정입니다.', '/membership/login');
          } else {
              // handleConfirm("", "병원 등록에 실패 하였습니다.");
              handleAlert('', '병원 등록에 실패 하였습니다.', '/cnntHspt');
          }
      })
      .catch(err => {
          console.log(err);
      });
    } else {
      handleAlert("", "개인정보동의에 체크하세요 .");
    }
  }

  return (
    <Fragment>
      <ContainerNew
        Title={"병원등록정보 수정"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        // bottom={bottom}
        isMain={true}
      >
        <Contents>
          <SubTitleCpnt hsptNm={props.match.params.hsptNm} />

          {/* input area */}
          <div>
            <DivTitle>이름</DivTitle>
            <InputDiv
              type="text"
              name="userName"
              placeholder="이름"
              defaultValue={defaultInfo.userName}
              maxLength={20}
              style={{ marginBottom: "16px", backgroundColor: "#f7f7f7", borderRadious: "8px" }}
            />

            <div style={{ display: "flex" }}>
              <div style={{ width: "70%" }}>
                <DivTitle>생년월일</DivTitle>
                <InputDiv
                  type="number"
                  pattern="\d*"
                  name="birth"
                  placeholder="예) 19901201"
                  defaultValue={defaultInfo.birth}
                  maxLength={8}
                  onChange={true}
                  style={{ marginBottom: "16px", backgroundColor: "#f7f7f7", borderRadious: "8px" }}
                />
              </div>

              <div style={{ marginLeft: "auto" }}>
                <DivTitle style={{ color: "#6200ee" }}>성별</DivTitle>
                <UserInfoGender setGender={setGender} gender={defaultInfo.sex} />
              </div>
            </div>

            <DivTitle>휴대폰번호</DivTitle>
            <InputDiv
              type="number"
              pattern="\d*"
              name="userPhone"
              placeholder="예) 01012345678"
              defaultValue={defaultInfo.userPhone}
              maxLength={11}
              onChange={true}
              style={{ marginBottom: "16px", backgroundColor: "#f7f7f7", borderRadious: "8px" }}
            />

            <DivTitle>{props.match.params.hsptNm} 환자ID(선택)</DivTitle>
            <InputDiv
              type="text"
              name="attchNo"
              placeholder="환자ID를 입력하세요"
              maxLength={12}
              onChange={true}
              style={{ marginBottom: "8px", backgroundColor: "#f7f7f7", borderRadious: "8px" }}
            />
            <div style={{ marginBottom: "16px" }}>※환자ID 입력시 쉽게 병원과 연결됩니다.</div>

            <div style={{ display: "flex" }}>
              {/* <label>
                <input type="checkbox" id="privateApply" style={{marginRight: "8px", marginLeft:"2px"}} />
                개인정보활용에 동의합니다.
              </label> */}

              <div>
                <ItemChecked id="privateApply" type={"checkbox"} />
              </div>
              <div>개인정보활용에 동의합니다.</div>
            </div>

            <div style={{ textAlign: "center", width: "auto", marginTop: "16px" }}>
              <BtnNext
                // innerWidth={window.innerWidth}
                onClick={() => {
                  updateHsptCnntEvent();
                }}
              >
                등록
              </BtnNext>
            </div>
          </div>
        </Contents>
      </ContainerNew>
      <AlertLayer title={dialog.title} msg={dialog.msg} url={dialog.url} />
      <ExistIdLayer dupList={dupList} />
    </Fragment>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const UserInfoGender = (props) => {
  const { setGender, gender } = props;
  console.log("gender :: ", gender);
  return (
    <div>
      <div className="select-custom-box">
        <a className="btn-select" style={{backgroundColor:"#f7f7f7"}}>{gender === "1" ? "남자" : "여자"}</a>
        <ul style={{backgroundColor:"#f7f7f7"}}>
          <li onClick={() => setGender("1")}>
            <a>남자</a>
          </li>
          <li onClick={() => setGender("0")}>
            <a>여자</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

const SubTitleCpnt = ({hsptNm}) => {
  return(
    <Fragment>
      <SubTitle>병원등록정보 수정</SubTitle>
      <div style={{ padding: "8px 0px" }}>
        <p>
          <font style={{ color: "red", fontSize: "16px", fontWeight: "700" }}>{hsptNm}에 등록된 정보</font>
          와 동일한지
          <font style={{ color: "red", fontSize: "16px", fontWeight: "700" }}>의료진과의 대면</font>으로
          확인이 필요합니다. 대면으로 <font style={{ color: "red", fontSize: "16px", fontWeight: "700" }}>본인확인</font> 하세요
        </p>
      </div>
    </Fragment>
  )
}

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;

const DivTitle = styled.div`
  padding-left: 4px;
  font-weight: 700;
  margin-bottom: 4px;
`

const DivErrTitle = styled.div`
  padding-left: 7px;
  font-weight: 700;
  margin-bottom: 4px;
`

const ItemChecked = styled.input`
  appearance: none !important;
  border: 1px solid #e0e0e0;
  border-radius: 1.5px;
  background-color: #fff !important;
  width: 18px;
  height: 18px;

  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% !important;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;